import { createAction, props } from '@ngrx/store';

import { CalendarTypeModel } from '@components/report-filters/filters/calendars-filter/models/calendarTypeModel';
import { IDatePeriod, IDatepickerValue } from '@xenial-ux/xux-datepicker/types';

export const ADD_EMPLOYEES = 'ADD_EMPLOYEES';
export const ADD_JOB_CATEGORIES = 'ADD_JOB_CATEGORIES';
export const ADD_DESTINATIONS = 'ADD_DESTINATIONS';
export const ADD_DAY_PARTS = 'ADD_DAY_PARTS';

export const RESET_FILTERS = 'RESET_FILTERS';
export const SET_BUSINESS_RULE_GROUP = 'SET_BUSINESS_RULE_GROUP';
export const SET_DATE_FOR_SINGLE_PICKER = 'SET_DATE_FOR_SINGLE_PICKER';
export const SET_DATE_FOR_MULTI_PICKER = 'SET_DATE_FOR_MULTI_PICKER';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const SET_SELECTED_VIEW = 'SET_SELECTED_VIEW';
export const SET_BUSINESS_DATE_AND_CALENDARS = 'SET_BUSINESS_DATE_AND_CALENDARS';
export const SET_STANDALONE_REPORT_FILTERS = 'SET_STANDALONE_REPORT_FILTERS';
export const SET_COMBINED_SELECT_FILTERS = 'SET_COMBINED_SELECT_FILTERS';
export const SET_DATE_TYPE_TO_CUSTOM = 'SET_DATE_TYPE_TO_CUSTOM';

export const add_employees = createAction(`[FILTERS_REDUCER] ${ADD_EMPLOYEES}`, props<{ employees: Array<any> }>());
export const add_job_categories = createAction(
    `[FILTERS_REDUCER] ${ADD_JOB_CATEGORIES}`,
    props<{ job_categories: Array<any> }>(),
);
export const add_destinations = createAction(
    `[FILTERS_REDUCER] ${ADD_DESTINATIONS}`,
    props<{ destinations: Array<{ id: string; name: string }> }>(),
);
export const add_day_parts = createAction(
    `[FILTERS_REDUCER] ${ADD_DAY_PARTS}`,
    props<{ day_parts: Array<{ id: string; name: string }> }>(),
);

export const reset_filters = createAction(`[FILTERS_REDUCER] ${RESET_FILTERS}`);
export const set_business_rule_group = createAction(
    `[FILTERS_REDUCER] ${SET_BUSINESS_RULE_GROUP}`,
    props<{ business_rule_groups: any }>(),
);
export const set_date_for_single_picker = createAction(
    `[FILTERS_REDUCER] ${SET_DATE_FOR_SINGLE_PICKER}`,
    props<{ selectedDateForSingleDate: IDatepickerValue }>(),
);

export const set_date_for_multi_picker = createAction(
    `[FILTERS_REDUCER] ${SET_DATE_FOR_MULTI_PICKER}`,
    props<{ selectedDateForMultiDate: IDatepickerValue }>(),
);
export const set_selected_view = createAction(
    `[FILTERS_REDUCER] ${SET_SELECTED_VIEW}`,
    props<{ selectedView: { [key: string]: string } }>(),
);
export const set_selected_date = createAction(
    `[FILTERS_REDUCER] ${SET_SELECTED_DATE}`,
    props<{
        typeOfCalendar: CalendarTypeModel;
        selectedDate: {
            type?: string;
            value?: string | IDatePeriod;
        };
        applied: boolean;
    }>(),
);
export const set_date_type_to_custom = createAction(
    `[FILTERS_REDUCER] ${SET_DATE_TYPE_TO_CUSTOM}`,
    props<{
        selectedDate: {
            type?: string;
            value?: IDatePeriod;
        };
        isDrillDown: boolean;
    }>(),
);

export const set_business_date_and_calendars = createAction(
    `[FILTERS_REDUCER] ${SET_BUSINESS_DATE_AND_CALENDARS}`,
    props<{
        businessDate: string;
        calendars: IDatePeriod[];
    }>(),
);

export const set_standalone_report_filters = createAction(
    `[FILTERS_REDUCER] ${SET_STANDALONE_REPORT_FILTERS}`,
    props<{ standaloneReportFilters: { [key: string]: string } }>(),
);

export const set_combined_select_filters = createAction(
    `[FILTERS_REDUCER] ${SET_COMBINED_SELECT_FILTERS}`,
    props<{ combinedSelectFilters: { [key: string]: { [key: string]: string } } }>(),
);
